import api from "./api";

// Fetch all businesses
export const fetchAllBusinesses = async () => {
  try {
    const response = await api.get('/business-management/businesses');
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching businesses:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch businesses" };
  }
};

// Update business status
export const updateBusinessStatus = async (businessId, status, statusReason = null) => {
  try {
    const payload = {
      status,
      ...(statusReason && { status_reason: statusReason }), // Include status_reason only if provided
    };

    const response = await api.put(`/business-management/businesses/${businessId}/status`, payload);

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating business status:", error.message || error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to update business status",
    };
  }
};

